import { Component, ViewEncapsulation } from '@angular/core';

import type { Subject } from 'rxjs';

@Component({
  selector: 'kp-tiia-confirm',
  templateUrl: './confirm.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class:
      'mx-4 w-[800px] rounded-sm border border-gray-300 bg-white p-4 shadow-lg',
  },
})
export class ConfirmComponent {
  close$: Subject<unknown> | undefined;
  justOk?: boolean;
  noBtn?: string;
  okBtn?: string;
  question?: string;
  title?: string;

  result(res: boolean): void {
    this.close$?.next(res);
  }
}
